/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { EmployeeInvite } from './EmployeeInvite';
import {
    EmployeeInviteFromJSON,
    EmployeeInviteFromJSONTyped,
    EmployeeInviteToJSON,
    EmployeeInviteToJSONTyped,
} from './EmployeeInvite';

/**
 * 
 * @export
 * @interface ListEmployeeInvitesResponse
 */
export interface ListEmployeeInvitesResponse {
    /**
     * 
     * @type {Array<EmployeeInvite>}
     * @memberof ListEmployeeInvitesResponse
     */
    data: Array<EmployeeInvite>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListEmployeeInvitesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListEmployeeInvitesResponse interface.
 */
export function instanceOfListEmployeeInvitesResponse(value: object): value is ListEmployeeInvitesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListEmployeeInvitesResponseFromJSON(json: any): ListEmployeeInvitesResponse {
    return ListEmployeeInvitesResponseFromJSONTyped(json, false);
}

export function ListEmployeeInvitesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmployeeInvitesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmployeeInviteFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListEmployeeInvitesResponseToJSON(json: any): ListEmployeeInvitesResponse {
      return ListEmployeeInvitesResponseToJSONTyped(json, false);
  }

  export function ListEmployeeInvitesResponseToJSONTyped(value?: ListEmployeeInvitesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EmployeeInviteToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

